<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 14 18">
  <path
    [attr.fill]="color"
    clip-rule="evenodd"
    d="M7 0C4.37811 2.1495 2.73467 2.25 0 2.25V10.9012C0 14.3535 2.49122 15.2542 7 18C11.5088 15.2542 14 14.3535 14 10.9012V2.25C11.2653 2.25 9.62189 2.1495 7 0ZM7 1.908C8.94444 3.26175 10.5428 3.627 12.4444 3.72V10.9012C12.4444 13.1827 11.1331 13.7715 7 16.2323C2.87078 13.7737 1.55556 13.1835 1.55556 10.9012V3.72C3.45878 3.627 5.05556 3.26175 7 1.908ZM7 4.875C9.36133 4.875 11.2778 6.723 11.2778 9C11.2778 11.277 9.36133 13.125 7 13.125C4.63867 13.125 2.72222 11.277 2.72222 9C2.72222 6.723 4.63867 4.875 7 4.875ZM7.77778 6.75H6.22222V8.25H4.66667V9.75H6.22222V11.25H7.77778V9.75H9.33333V8.25H7.77778V6.75Z"
    fill-rule="evenodd"
  />
</svg>
